
import * as ipxRuntime$YoBhFvglqwma5zrzV5v6Yb64P9TPNcP7gFb3M9e4QxU from '/root/work/frontends/kakao_gino/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@8.2.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$YoBhFvglqwma5zrzV5v6Yb64P9TPNcP7gFb3M9e4QxU, defaults: {} }
}
        